import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import Login from './components/Login/Login'; // Dosya yolunu kontrol et kanka
import DashBoard from './components/Dashboard/DashBoard';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './components/firebase/firebase-config';
import './App.css';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });
    
    // Temizlik fonksiyonu
    return () => unsubscribe();
  }, []);

  if (loading) return (
    <div className="loading-container">
      <div className="spinner"></div>
      <p>Bigma Yönetim Paneli Hazırlanıyor...</p>
    </div>
  );

  return (
    <Routes>
      
      <Route 
        path="/" 
        element={!user ? <Login /> : <Navigate to="/dashboard" />} 
      />

      {/* Panel Rotası: Sadece giriş yapmış kullanıcılar (user) görebilir */}
      <Route 
        path="/dashboard" 
        element={user ? <DashBoard /> : <Navigate to="/" />} 
      />
      
      {/* Tanımsız bir sayfaya gidilirse ana sayfaya fırlat */}
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

export default App;